import i18n, { loadNamespaces } from 'i18next';

type TranslationId =
    | 'addressbook'
    | 'aviso'
    | 'eInvoice'
    | 'gdpr'
    | 'health'
    | 'hey-george'
    | 'notifications'
    | 'pfm'
    | 'plugins'
    | 'profile'
    | 'saving'
    | 'securities'
    | 'settings'
    | 'shop'
    | 'watchdogs'
    | 'fitcz'
    | 'experts'
    | 'multibanking';

export function loadTranslationNamespace(translationId: TranslationId): Promise<void> {
    return loadNamespaces(translationId);
}

export function addResourceBundle(...args: Parameters<typeof i18n.addResourceBundle>): void {
    i18n.addResourceBundle(...args);
}

export function hasResourceBundle(...args: Parameters<typeof i18n.hasResourceBundle>): boolean {
    return i18n.hasResourceBundle(...args);
}

export function getResourceBundle(
    ...args: Parameters<typeof i18n.getResourceBundle>
): ReturnType<typeof i18n.getResourceBundle> {
    return i18n.getResourceBundle(...args);
}
